
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexC2THWMpQmaS_V6nYg79tIhdbNipfnNpXDkadlC3dfgYMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/index.vue?macro=true";
import { default as loginrUjy1OrFwEPvhtAVDtwKimtCqqWLF0BNmOD2WFWkBVMMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/login.vue?macro=true";
import { default as logoutiOVCyvcMAxEJhBppU8V_45zJukudTA_45UoPD_45LayiMSi84Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/logout.vue?macro=true";
import { default as redirectHHLDPF_TcxaDksoLc2Wl0WQKxindhvWrGn28g4kijiQMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/redirect.vue?macro=true";
import { default as app_45loginyNxbxlVP4ckpgEod0xwM8b8V9oWuQmDYk5o3IiK_8JAMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/app-login.vue?macro=true";
import { default as allGADutiKt_pfa7bPR48leLjVwE56WJZEjnCIbyG_dnjUMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/inbox/all.vue?macro=true";
import { default as indexk3rEGi3eKm0SZvz4M6LOkJiGypVeiKvx75bD1dG6Yz4Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/index.vue?macro=true";
import { default as piniaDGwi2Qb9f58Awh7NxPFQPSp_45flHE6y7tROhWIFvB_452MMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/pinia.vue?macro=true";
import { default as invalid_45urli4G9nh21HSQzfrb1Jd5HYKTgiy3FtYaNjVTZ4bn1YcEMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/invalid-url.vue?macro=true";
import { default as errorszYr6DUCNIGxYuZs9nbEgZk4o98sQyOTBxVoH4T6TgY8Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/errors.vue?macro=true";
import { default as auth_453aOUWByjj31yDN60Z9jiBiTVdk3FFOEohwGppNMtUIMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar/auth.vue?macro=true";
import { default as testedAk_zVtMUW_45ry77KA6oJGg1bIcbmLxrKXlLmExOmjgMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar/test.vue?macro=true";
import { default as account_45status2UGWhzj_Dl4DWcvWICohvDTWLnQM_45auD7QDoMabsw1oMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/account-status.vue?macro=true";
import { default as indexKJdBSuQ9_45GKNORy2kZdld6FeZ9qpsRAgOHV_450UsCmdUMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar/index.vue?macro=true";
import { default as clerk_45redirectvSUQAYorRkXCzPeQf_xHflQ1qOOfgl2k30_45cZ9bLk0IMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/clerk-redirect.vue?macro=true";
import { default as inbox_45redirectxzYVn9Mm9SzhQ2FRzBIhHnYJvfYeFpncCb8zJWRU5WoMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/inbox-redirect.vue?macro=true";
import { default as forgot_45passwordtpHosYY4Lbg4oHI5Yc3orRyi8pk8CJ4d7j6bEu59hj0Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/forgot-password.vue?macro=true";
import { default as logout_45redirect_45A6Y_45jAnP9iJLbl1H42TO2E8aGcGmzFGlYbMr6eKSuYMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/logout-redirect.vue?macro=true";
import { default as tabspckREiahcSl1w4S4U0wmJ6xxNWjvfS_45lav_0qexq0VIMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/tabs.vue?macro=true";
import { default as statsczReH4rKjwsFWnVFNhJ9wlyji83b0DSVl_45fKc9LfUbIMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/stats.vue?macro=true";
import { default as _91bookingId_93lbEYSOyPx4FATkqiIxIlYbmG6SzuAxSl78x9KSwY928Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/book/[bookingId].vue?macro=true";
import { default as lists0f6eapBWyNfA24vzVusM7bE4BfOzz_OZnnwtaWcV9hAMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/lists.vue?macro=true";
import { default as user_45preferencesqMrgdhwZXH4nLEJkltgtHt4wWSCPxtuQqwe21i4s9YoMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/user-preferences.vue?macro=true";
import { default as onboarduXaks_9lZB4KqINH0udJ_459imOkQdwKG3q3MW4Ec4gxgMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/whatsapp/onboard.vue?macro=true";
import { default as images2KjwZ2NhItp2owuhfxEJZzlJW_KEgvGLU2ReAME7Q5sMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/images.vue?macro=true";
import { default as inputsk48Aq8xbXEOaaz2UwfNqZMcHve0Dai_QlPHelQUYX_oMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/inputs.vue?macro=true";
import { default as buttonsPZRxxMcoRO_Cblq92d9QrxlJjgsJ3dx3RZ_5_455lajMcMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/buttons.vue?macro=true";
import { default as divider1uWaRwwRAUGbsdl6_45_ZbtInOgf3q2mp4_45LU7SKGX_aMMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/divider.vue?macro=true";
import { default as chat4l3Mu_dHpvyTWDWOZWag_OXL1yO5xxMQFL2UI16N9YsMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/chat.vue?macro=true";
import { default as kpisoB3LlkK8cEABxxlRl2AQiVFb_2Eesx_457btoj17yGJgsMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/kpis.vue?macro=true";
import { default as listLwJnpB824ouXmZgTf0paldFYawSno28KbdlrroOXMpwMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/list.vue?macro=true";
import { default as seat4aJ_LoZLZbTb7Ktx0w7zlrc20eCqa4UWxpT2yxsnR0kMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/seat.vue?macro=true";
import { default as local_45storageyfv70Sv00CwKtl64ye_455pgIR4D2Wq5_45cB99fZjQJxtAMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/local-storage.vue?macro=true";
import { default as invalid_45permissionsq0F2Rg7xax_IRw_45HrlCulcz_OcE0dL_45iQEZCQ6T93kwMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/invalid-permissions.vue?macro=true";
import { default as flagsYASgWGoZZsm8qZOgx4B4e5FtLEx8lWYtGzUe7bdLS5cMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/flags.vue?macro=true";
import { default as logosNjpSWZZPoxLquEFAN655ljC2Naa91t9bNRLr1_mCywcMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/logos.vue?macro=true";
import { default as menusHPXmTAeTFQFtNUUGN6Uzu_45SdCw_45FZdsnoqZmzRszot0Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/menus.vue?macro=true";
import { default as textsjeE2Gg3wtQnbMoGIFtrP_AMyAqTieoZAyHAEWfQcoUIMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/texts.vue?macro=true";
import { default as chips_45and_45tagsTnt5E61CN0nm_M_ASsBYLhlWm9ag43hkzqfFpIaSeF4Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/chips-and-tags.vue?macro=true";
import { default as texttsVi47MFWgY9bEv7I3A7WGOgLsKclJJEfORSa_45fG_45fAMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/text.vue?macro=true";
import { default as tablesC_INZqdjVo9b7S5NU8B_woUnJqQYZlyGmqKGVmsAtjMMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/tables.vue?macro=true";
import { default as menusDgmca1fcYCy4WgTFV0Gif0uXS3zfWyyR62aRXdQcIWoMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/menus.vue?macro=true";
import { default as calendaryBp3wTl1mWCru6cyjQB2q0x20VE5UxJZiIxMD3Zsm5kMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/early-access/calendar.vue?macro=true";
import { default as onboardingsuPD79Ox9zy1TocZfQteCY5QzOhI6OttXFpL61UwhaYMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/onboarding.vue?macro=true";
import { default as avatarsY4Qmpr6iANiE2ploWE15T5bNcgeGahV47bI9gymQBpgMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/avatars.vue?macro=true";
import { default as cookiesOferOnZzEpxY_457N2qOLNzxTHOgkFCsMHFX9KmpS5oREMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/cookies.vue?macro=true";
import { default as chrome_45extensionIVjcW1SS0j9FiQobAPOJ9Fya1HPmeC2RAP0DslziB38Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/chrome-extension.vue?macro=true";
import { default as indexppwCyLaLcSEyzCDDNReSWa_45M6cRl7lZiNF5oFUCC3dYMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/chrome-extension/index.vue?macro=true";
import { default as indexKxAY1QXtAwWWQj8Saua_ID44xl0xsNw8xnRkwOL_45jrIMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/seats/[tenantId]/index.vue?macro=true";
import { default as breadcrumbs93eLrV9spe3M8pFw8_45cBXlfMpJ1NCcZ_6eUT3v9QPbwMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/breadcrumbs.vue?macro=true";
import { default as buttonsqkD6MiPLK81_45BaXwofdkRi_Lxx74nZ_45hH_SpWIuFD3cMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/buttons.vue?macro=true";
import { default as footersx3ra09oTo73G3qURZF7d8OpmmDyvwg4MLUMYTaY_45GzIMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/footers.vue?macro=true";
import { default as loadingFratR9_vQ07WVZd_L6DBoRvLjUrtSvtrzdqcaYdwU6QMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/loading.vue?macro=true";
import { default as steppervYWQ39OBFbaMh_ovGs0wQGR_VjIpJ6yphgCN4lfIDgsMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/stepper.vue?macro=true";
import { default as autocompleteH_45_45yQDXr4aCyeuF7qcUwhhievMnh9DcArMFQ_3BtLN8Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/autocomplete.vue?macro=true";
import { default as header4bzaF63pphJSU27M7KrZHQWrM9MGJVfY03pTHRp6Cd4Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/grids/header.vue?macro=true";
import { default as typographiesNFXe_puXu3mz_45sRq_Y_45xW0PxW05Bw0JMvIZSvZH9GZsMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/typographies.vue?macro=true";
import { default as templatesyZOO56zqO6W7Lq2C75y7RLpoHHXSK72q7N6Z528aG6MMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/templates.vue?macro=true";
import { default as variablesoJOJJmL9I0Rpw_45eLCJ_45krbMDG6vMFr1plbBLCci3_GkMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/variables.vue?macro=true";
import { default as voice_45calls7Lqtbd5v5tG4RajLDUBNWI5NQXgouLF7KLmheYAEJ04Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/early-access/voice-calls.vue?macro=true";
import { default as indexE05bh62g99mIG6JzUtjqwwJ2YgT2S0KHUUbjVAZfvIwMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/download-pdf/[hash]/index.vue?macro=true";
import { default as pagination7dhrv8LLeW0bB7RFd1J5AWQrmjmlKPUmTwww8y_45H0sgMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/pagination.vue?macro=true";
import { default as nylas_45oauth_45handshakeqcEUxVzx1D_45LoBeI7glF7Q2FhP6ZYJtlgAHQXMy0UNgMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/book/nylas-oauth-handshake.vue?macro=true";
import { default as no_45header1i0D1RYKS0UXFErxF9ye5l_4Y3PuweYrfyOORZ3fImEMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/grids/no-header.vue?macro=true";
import { default as urlShortenerBVPcwTZ9xS_GqFGPHW92vOT1n9waWIfHpOJwWm35UQEMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/urlShortener.vue?macro=true";
import { default as transitionsAVA9qXZjqyfb5fNi5S9DiYFN5hy8C7YfEkPPGrubafcMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/transitions.vue?macro=true";
import { default as _91eventId_93cbsslFEvKb4CSr0ZLUKVmqIaH6opoIR8SX5nuuij__450Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar-invitation/[eventId].vue?macro=true";
import { default as indexdbeggkaRKu8USY3SHlwoQsHh33f7TXhrf4aUQTRAxrgMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/integrations/[tenantId]/index.vue?macro=true";
import { default as whatsapp_45messagingQjSeNXZLjoIdaxRsS4vQ_e0K4Ep5mt046da7iD_45qUQwMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/early-access/whatsapp-messaging.vue?macro=true";
import { default as index0ClUDgWDt988__8gAf5dS_yXKt4DPgqQrGbaFpI9xBAMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/shared-templates/[tenantId]/index.vue?macro=true";
import { default as indexT_au7sMZcyOa5k3Ewr47xH1QsCVJaNXOu5nMlaiA0QoMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/password-set/[loginId]/[token]/index.vue?macro=true";
import { default as _91tenantId_93TYwSW2ZPhC44obxu837uh7hJW97umjk8S1k0JfvY7xoMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/metrics/messages-campaigns/[tenantId].vue?macro=true";
import { default as indexP4Sbnd53UJPmKDR7utypk47niBecR4Wz7ZOOrNN1UuoMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/inbox/index.vue?macro=true";
import { default as indexNQElshl1sf46Hy4NfoPkSKpudYM_45yblhwvcMWLOdPvYMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/inbox/[tenantId]/[phoneNumberId]/index.vue?macro=true";
import { default as indexPEPOcntwoeEdU5AcpNB2f6nVe_77YEwmdUs_t8B_oroMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/contacts/index.vue?macro=true";
import { default as indexKGPW5WZXbrMc6lNUPVbnQoWsMUsUjXV69ZYb9BNborYMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/contacts/[tenantId]/[phoneNumberId]/index.vue?macro=true";
import { default as indexhXDCrM1gh2Occxwe8zUiRsvz4DiGtJORk3ezBeE72aQMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/call-logs/[tenantId]/[phoneNumberId]/index.vue?macro=true";
import { default as indexElYg55SrjJHqa_45s_E1HSGFvich0CkGkmWMb26cEWh1cMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/sms-campaigns/index.vue?macro=true";
import { default as indexGxQI_I2MRKs3a2RCAgSjp_2bBjNyQSU67_45U5wgNcAQ8Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/index.vue?macro=true";
import { default as indexIeHdo3Q04_45FweJxKP3zOoglfG_453vLdXuuIm7Yc4B9vcMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/inbox/[threadId]/index.vue?macro=true";
import { default as indexa1aqnAMy113kCFZJrCjwWHali3_Dbh283Xf4y7yC7F0Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/oneoff-campaigns/[tenantId]/[phoneNumberId]/index.vue?macro=true";
import { default as createYMh_45RYnYJk_45oV9A403Y5YU0ZVIWh5IygUnHqf59ZO20Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/oneoff-campaigns/[tenantId]/[phoneNumberId]/create.vue?macro=true";
import { default as indexnKpYmcj30elkTrUZPBLBvQn0PFIQ5ogjkCmoGc1ePbYMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/whatsapp-templates/[tenantId]/[phoneNumberId]/index.vue?macro=true";
import { default as _91campaignId_93Fmapz7a6SHJIA6Gc3x_r8dcT80hTIDxhp5KbEgJfq0EMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/sms-campaigns/[campaignId].vue?macro=true";
import { default as index32dmfJwDhb7wFeZItgsHG_45UfxKTgYxlc7eWyEW92zQ4Meta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/index.vue?macro=true";
import { default as createMmABp9wvpHuTlF0SGeXBfoINzwQ9fQJeGjinqeRY1LEMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/create.vue?macro=true";
import { default as updateaXNRbjyknsbdtiNi8PN04NU_Vq_45UMwHM7HyuGHJ1h1AMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/oneoff-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/update.vue?macro=true";
import { default as updateMessagesB4B2AiCeXvQBbYlMjqfN7UjuEHKqGAmoSoJKn90PPcAMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/updateMessages.vue?macro=true";
import { default as updateRecipientsKodu73mPZ_455AbKndmnRMWuxOH_45VAjHho2KqqbProgGoMeta } from "/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/updateRecipients.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginrUjy1OrFwEPvhtAVDtwKimtCqqWLF0BNmOD2WFWkBVMMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutiOVCyvcMAxEJhBppU8V_45zJukudTA_45UoPD_45LayiMSi84Meta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/logout.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    meta: redirectHHLDPF_TcxaDksoLc2Wl0WQKxindhvWrGn28g4kijiQMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/redirect.vue")
  },
  {
    name: "app-login",
    path: "/app-login",
    meta: app_45loginyNxbxlVP4ckpgEod0xwM8b8V9oWuQmDYk5o3IiK_8JAMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/app-login.vue")
  },
  {
    name: "inbox-all",
    path: "/inbox/all",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/inbox/all.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/index.vue")
  },
  {
    name: "test-pinia",
    path: "/test/pinia",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/pinia.vue")
  },
  {
    name: "invalid-url",
    path: "/invalid-url",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/invalid-url.vue")
  },
  {
    name: "test-errors",
    path: "/test/errors",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/errors.vue")
  },
  {
    name: "calendar-auth",
    path: "/calendar/auth",
    meta: auth_453aOUWByjj31yDN60Z9jiBiTVdk3FFOEohwGppNMtUIMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar/auth.vue")
  },
  {
    name: "calendar-test",
    path: "/calendar/test",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar/test.vue")
  },
  {
    name: "account-status",
    path: "/account-status",
    meta: account_45status2UGWhzj_Dl4DWcvWICohvDTWLnQM_45auD7QDoMabsw1oMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/account-status.vue")
  },
  {
    name: "calendar",
    path: "/calendar",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar/index.vue")
  },
  {
    name: "clerk-redirect",
    path: "/clerk-redirect",
    meta: clerk_45redirectvSUQAYorRkXCzPeQf_xHflQ1qOOfgl2k30_45cZ9bLk0IMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/clerk-redirect.vue")
  },
  {
    name: "inbox-redirect",
    path: "/inbox-redirect",
    meta: inbox_45redirectxzYVn9Mm9SzhQ2FRzBIhHnYJvfYeFpncCb8zJWRU5WoMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/inbox-redirect.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordtpHosYY4Lbg4oHI5Yc3orRyi8pk8CJ4d7j6bEu59hj0Meta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/forgot-password.vue")
  },
  {
    name: "logout-redirect",
    path: "/logout-redirect",
    meta: logout_45redirect_45A6Y_45jAnP9iJLbl1H42TO2E8aGcGmzFGlYbMr6eKSuYMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/logout-redirect.vue")
  },
  {
    name: "test-atoms-tabs",
    path: "/test/atoms/tabs",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/tabs.vue")
  },
  {
    name: "tenantId-stats",
    path: "/:tenantId()/stats",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/stats.vue")
  },
  {
    name: "book-bookingId",
    path: "/book/:bookingId()",
    meta: _91bookingId_93lbEYSOyPx4FATkqiIxIlYbmG6SzuAxSl78x9KSwY928Meta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/book/[bookingId].vue")
  },
  {
    name: "test-atoms-lists",
    path: "/test/atoms/lists",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/lists.vue")
  },
  {
    name: "user-preferences",
    path: "/user-preferences",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/user-preferences.vue")
  },
  {
    name: "whatsapp-onboard",
    path: "/whatsapp/onboard",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/whatsapp/onboard.vue")
  },
  {
    name: "test-atoms-images",
    path: "/test/atoms/images",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/images.vue")
  },
  {
    name: "test-atoms-inputs",
    path: "/test/atoms/inputs",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/inputs.vue")
  },
  {
    name: "test-atoms-buttons",
    path: "/test/atoms/buttons",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/buttons.vue")
  },
  {
    name: "test-atoms-divider",
    path: "/test/atoms/divider",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/divider.vue")
  },
  {
    name: "test-business-chat",
    path: "/test/business/chat",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/chat.vue")
  },
  {
    name: "test-business-kpis",
    path: "/test/business/kpis",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/kpis.vue")
  },
  {
    name: "test-business-list",
    path: "/test/business/list",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/list.vue")
  },
  {
    name: "test-business-seat",
    path: "/test/business/seat",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/seat.vue")
  },
  {
    name: "test-local-storage",
    path: "/test/local-storage",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/local-storage.vue")
  },
  {
    name: "invalid-permissions",
    path: "/invalid-permissions",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/invalid-permissions.vue")
  },
  {
    name: "test-business-flags",
    path: "/test/business/flags",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/flags.vue")
  },
  {
    name: "test-business-logos",
    path: "/test/business/logos",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/logos.vue")
  },
  {
    name: "test-business-menus",
    path: "/test/business/menus",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/menus.vue")
  },
  {
    name: "test-business-texts",
    path: "/test/business/texts",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/texts.vue")
  },
  {
    name: "test-chips-and-tags",
    path: "/test/chips-and-tags",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/chips-and-tags.vue")
  },
  {
    name: "test-molecules-text",
    path: "/test/molecules/text",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/text.vue")
  },
  {
    name: "test-business-tables",
    path: "/test/business/tables",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/tables.vue")
  },
  {
    name: "test-molecules-menus",
    path: "/test/molecules/menus",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/menus.vue")
  },
  {
    name: "early-access-calendar",
    path: "/early-access/calendar",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/early-access/calendar.vue")
  },
  {
    name: "test-atoms-onboarding",
    path: "/test/atoms/onboarding",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/onboarding.vue")
  },
  {
    name: "test-business-avatars",
    path: "/test/business/avatars",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/avatars.vue")
  },
  {
    name: "test-business-cookies",
    path: "/test/business/cookies",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/cookies.vue")
  },
  {
    name: "test-chrome-extension",
    path: "/test/chrome-extension",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/chrome-extension.vue")
  },
  {
    name: "chrome-extension",
    path: "/chrome-extension",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/chrome-extension/index.vue")
  },
  {
    name: "seats-tenantId",
    path: "/seats/:tenantId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/seats/[tenantId]/index.vue")
  },
  {
    name: "test-atoms-breadcrumbs",
    path: "/test/atoms/breadcrumbs",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/breadcrumbs.vue")
  },
  {
    name: "test-molecules-buttons",
    path: "/test/molecules/buttons",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/buttons.vue")
  },
  {
    name: "test-molecules-footers",
    path: "/test/molecules/footers",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/footers.vue")
  },
  {
    name: "test-molecules-loading",
    path: "/test/molecules/loading",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/loading.vue")
  },
  {
    name: "test-molecules-stepper",
    path: "/test/molecules/stepper",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/stepper.vue")
  },
  {
    name: "test-atoms-autocomplete",
    path: "/test/atoms/autocomplete",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/autocomplete.vue")
  },
  {
    name: "test-atoms-grids-header",
    path: "/test/atoms/grids/header",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/grids/header.vue")
  },
  {
    name: "test-atoms-typographies",
    path: "/test/atoms/typographies",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/typographies.vue")
  },
  {
    name: "test-business-templates",
    path: "/test/business/templates",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/templates.vue")
  },
  {
    name: "test-business-variables",
    path: "/test/business/variables",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/variables.vue")
  },
  {
    name: "early-access-voice-calls",
    path: "/early-access/voice-calls",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/early-access/voice-calls.vue")
  },
  {
    name: "download-pdf-hash",
    path: "/download-pdf/:hash()",
    meta: indexE05bh62g99mIG6JzUtjqwwJ2YgT2S0KHUUbjVAZfvIwMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/download-pdf/[hash]/index.vue")
  },
  {
    name: "test-molecules-pagination",
    path: "/test/molecules/pagination",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/pagination.vue")
  },
  {
    name: "book-nylas-oauth-handshake",
    path: "/book/nylas-oauth-handshake",
    meta: nylas_45oauth_45handshakeqcEUxVzx1D_45LoBeI7glF7Q2FhP6ZYJtlgAHQXMy0UNgMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/book/nylas-oauth-handshake.vue")
  },
  {
    name: "test-atoms-grids-no-header",
    path: "/test/atoms/grids/no-header",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/atoms/grids/no-header.vue")
  },
  {
    name: "test-business-urlShortener",
    path: "/test/business/urlShortener",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/business/urlShortener.vue")
  },
  {
    name: "test-molecules-transitions",
    path: "/test/molecules/transitions",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/test/molecules/transitions.vue")
  },
  {
    name: "calendar-invitation-eventId",
    path: "/calendar-invitation/:eventId()",
    meta: _91eventId_93cbsslFEvKb4CSr0ZLUKVmqIaH6opoIR8SX5nuuij__450Meta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/calendar-invitation/[eventId].vue")
  },
  {
    name: "integrations-tenantId",
    path: "/integrations/:tenantId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/integrations/[tenantId]/index.vue")
  },
  {
    name: "early-access-whatsapp-messaging",
    path: "/early-access/whatsapp-messaging",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/early-access/whatsapp-messaging.vue")
  },
  {
    name: "shared-templates-tenantId",
    path: "/shared-templates/:tenantId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/shared-templates/[tenantId]/index.vue")
  },
  {
    name: "password-set-loginId-token",
    path: "/password-set/:loginId()/:token()",
    meta: indexT_au7sMZcyOa5k3Ewr47xH1QsCVJaNXOu5nMlaiA0QoMeta || {},
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/password-set/[loginId]/[token]/index.vue")
  },
  {
    name: "metrics-messages-campaigns-tenantId",
    path: "/metrics/messages-campaigns/:tenantId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/metrics/messages-campaigns/[tenantId].vue")
  },
  {
    name: "tenantId-phoneNumberId-inbox",
    path: "/:tenantId()/:phoneNumberId()/inbox",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/inbox/index.vue")
  },
  {
    name: "inbox-tenantId-phoneNumberId",
    path: "/inbox/:tenantId()/:phoneNumberId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/inbox/[tenantId]/[phoneNumberId]/index.vue")
  },
  {
    name: "tenantId-phoneNumberId-contacts",
    path: "/:tenantId()/:phoneNumberId()/contacts",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/contacts/index.vue")
  },
  {
    name: "contacts-tenantId-phoneNumberId",
    path: "/contacts/:tenantId()/:phoneNumberId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/contacts/[tenantId]/[phoneNumberId]/index.vue")
  },
  {
    name: "call-logs-tenantId-phoneNumberId",
    path: "/call-logs/:tenantId()/:phoneNumberId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/call-logs/[tenantId]/[phoneNumberId]/index.vue")
  },
  {
    name: "tenantId-phoneNumberId-sms-campaigns",
    path: "/:tenantId()/:phoneNumberId()/sms-campaigns",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/sms-campaigns/index.vue")
  },
  {
    name: "drip-campaigns-tenantId-phoneNumberId",
    path: "/drip-campaigns/:tenantId()/:phoneNumberId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/index.vue")
  },
  {
    name: "tenantId-phoneNumberId-inbox-threadId",
    path: "/:tenantId()/:phoneNumberId()/inbox/:threadId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/inbox/[threadId]/index.vue")
  },
  {
    name: "oneoff-campaigns-tenantId-phoneNumberId",
    path: "/oneoff-campaigns/:tenantId()/:phoneNumberId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/oneoff-campaigns/[tenantId]/[phoneNumberId]/index.vue")
  },
  {
    name: "oneoff-campaigns-tenantId-phoneNumberId-create",
    path: "/oneoff-campaigns/:tenantId()/:phoneNumberId()/create",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/oneoff-campaigns/[tenantId]/[phoneNumberId]/create.vue")
  },
  {
    name: "whatsapp-templates-tenantId-phoneNumberId",
    path: "/whatsapp-templates/:tenantId()/:phoneNumberId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/whatsapp-templates/[tenantId]/[phoneNumberId]/index.vue")
  },
  {
    name: "tenantId-phoneNumberId-sms-campaigns-campaignId",
    path: "/:tenantId()/:phoneNumberId()/sms-campaigns/:campaignId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/[tenantId]/[phoneNumberId]/sms-campaigns/[campaignId].vue")
  },
  {
    name: "drip-campaigns-tenantId-phoneNumberId-campaignId",
    path: "/drip-campaigns/:tenantId()/:phoneNumberId()/:campaignId()",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/index.vue")
  },
  {
    name: "drip-campaigns-tenantId-phoneNumberId-campaignId-create",
    path: "/drip-campaigns/:tenantId()/:phoneNumberId()/:campaignId()/create",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/create.vue")
  },
  {
    name: "oneoff-campaigns-tenantId-phoneNumberId-campaignId-update",
    path: "/oneoff-campaigns/:tenantId()/:phoneNumberId()/:campaignId()/update",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/oneoff-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/update.vue")
  },
  {
    name: "drip-campaigns-tenantId-phoneNumberId-campaignId-updateMessages",
    path: "/drip-campaigns/:tenantId()/:phoneNumberId()/:campaignId()/updateMessages",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/updateMessages.vue")
  },
  {
    name: "drip-campaigns-tenantId-phoneNumberId-campaignId-updateRecipients",
    path: "/drip-campaigns/:tenantId()/:phoneNumberId()/:campaignId()/updateRecipients",
    component: () => import("/home/runner/work/emissary-webgui/emissary-webgui/pages/drip-campaigns/[tenantId]/[phoneNumberId]/[campaignId]/updateRecipients.vue")
  }
]